import React from 'react';
import '../App.css';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

import {
    Link
  } from "react-router-dom";

var labels = { textAlign:'center', fontSize: ".8em", marginTop: 10, color:'silver', fontWeight:"200" }
var sections = { textAlign:'left', fontSize: "1.3em", marginTop: 10, color:'rgba(123, 237, 159,1.0)', fontWeight:"200" }


var process = <p style={{ color:'white', fontSize: "1.4em", marginTop:30, fontWeight:"200", padding: 15 }}>
1 - Choose a component
<br />
<br />
2 - Customize it using the settings sliders
<br />
<br />
3 - Copy and paste the code generated by React Studio
<br />
<br />
Enjoy !
</p>

class Studio extends React.Component {

    constructor(props) {
        super(props);    
        this.state = {
            myComponentSelected: '',
            actionText:"",

            myComponent:"",

            showcaseRed:255,
            showcaseGreen:255,
            showcaseBlue:255,

            //size button
            value: 250,
            value2: 90,

            sizeWidthVideo:640,
            sizeHeightVideo: 358,

            sizeWidthImage: 400,
            sizeHeightImage: 200,

            //radius bouton
            value3:0,

            //text
            valueButtonText:"My button !",
            textRed:255,
            textGreen:255,
            textBlue:255,
            textSize: 18,

            //button color
            red:50,
            green:50,
            blue:50,

            //border
            borderW:0,
            borderRed:90,
            borderGreen:90,
            borderBlue:90,

            //box shadow
            shadowRed:0,
            shadowGreen:0,
            shadowBlue:0,
            shadowTop:0,
            shadowRight:0,
            shadowBottom:0,
            shadowLeft:0,


            //image 3D
            imgRotate:0,
            imgRotateX:0,
            imgRotateY:0,
            imgRotateZ:0,
            imgsScale: 1,
            skewX:0,
            skewY:0,

            alignText: 1,
            alignment: 'center',

            data1: 30,
            data2: 20,
            data3: 45,
            data4: 80,
            data5: 13,

            fromGradRed:0,
            fromGradGreen:0,
            fromGradBlue: 0,
            toGradRed: 0,
            toGradGreen: 0,
            toGradBlue: 0,

            myGradientType: 'linear',

            sliderWidth: 200,
            sliderHeight: 5,

            borderTopLeftRad:0,
            borderTopRightRad:0,
            borderBottomLeftRad:0,
            borderBottomRightRad:0,
            widthCard: 350,
            heightCard: 465,
            widthImageCard: 350,
            heightImageCard: 150,
            widthButtonCard: 150,
            heightButtonCard: 65,
            colorTextCardRed: 255,
            colorTextCardGreen: 255,
            colorTextCardBlue: 255,
            textSizeCard: 20,

        }
        
    this.handleChangeComponent = this.handleChangeComponent.bind(this);
    this.handleGradientType = this.handleGradientType.bind(this);
    this.handleChange = this.handleChange.bind(this);
}


handleGradientType(event){
    this.setState({ myGradientType: event.target.value });
}

handleChangeComponent (event){
    this.setState({
        myComponentSelected: '',
        actionText:"",

        myComponent:"",

        showcaseRed:255,
        showcaseGreen:255,
        showcaseBlue:255,

        //size button
        value: 250,
        value2: 90,

        sizeWidthVideo:640,
        sizeHeightVideo: 358,

        sizeWidthImage: 400,
        sizeHeightImage: 200,

        //radius bouton
        value3:0,

        //text
        valueButtonText:"My button !",
        textRed:255,
        textGreen:255,
        textBlue:255,
        textSize: 18,

        //button color
        red:50,
        green:50,
        blue:50,

        //border
        borderW:0,
        borderRed:90,
        borderGreen:90,
        borderBlue:90,

        //box shadow
        shadowRed:0,
        shadowGreen:0,
        shadowBlue:0,
        shadowTop:0,
        shadowRight:0,
        shadowBottom:0,
        shadowLeft:0,


        //image 3D
        imgRotate:0,
        imgRotateX:0,
        imgRotateY:0,
        imgRotateZ:0,
        imgsScale: 1,
        skewX:0,
        skewY:0,

        alignText: 1,
        alignment: 'center',

        data1: 30,
        data2: 20,
        data3: 45,
        data4: 80,
        data5: 13,

        fromGradRed:0,
        fromGradGreen:0,
        fromGradBlue: 0,
        toGradRed: 0,
        toGradGreen: 0,
        toGradBlue: 0,

        myGradientType: 'linear',

        sliderWidth: 200,
        sliderHeight: 5,

        borderTopLeftRad:0,
        borderTopRightRad:0,
        borderBottomLeftRad:0,
        borderBottomRightRad:0,
        widthCard: 350,
        heightCard: 465,
        widthImageCard: 350,
        heightImageCard: 150,
        widthButtonCard: 150,
        heightButtonCard: 65,
        colorTextCardRed: 255,
        colorTextCardGreen: 255,
        colorTextCardBlue: 255,
        textSizeCard: 20,
        })

    this.setState({ myComponentSelected: event.target.value, myComponent: event.target.value });
}

handleChange(e) {
    this.setState({ valueButtonText: e.target.value });
  }
  

render(){

        var cursorsBackShowcase = <span style={{ display:"flex", flexDirection:'row', justifyContent: "flex-end", position:'fixed', right:30, top: 70 }}>    
            
            <span style={{ width: "100px", margin: 20 }}><InputRange
            maxValue={255}
            minValue={0}
            value={this.state.showcaseRed}
            onChange={showcaseRed => this.setState({ showcaseRed })} />
            <br/>        
            <p style={labels}>Red</p>
            </span>

            <span style={{ width: "100px", margin: 20 }}><InputRange
            maxValue={255}
            minValue={0}
            value={this.state.showcaseGreen}
            onChange={showcaseGreen => this.setState({ showcaseGreen })} />   
            <br/>                
            <p style={labels}>Green</p>
            </span>
            <span style={{ width: "100px", margin: 20 }}><InputRange
            maxValue={255}
            minValue={0}
            value={this.state.showcaseBlue}
            onChange={showcaseBlue => this.setState({ showcaseBlue })} />
            <br/>        
            <p style={labels}>Blue</p>
            </span>
        </span>;


        var colorTitleShowcase = 'white'
        
        if(this.state.showcaseRed === 255 && this.state.showcaseGreen === 255 && this.state.showcaseRed === 255){
            colorTitleShowcase = "black"
        }

        var alignment = "center"
        if(this.state.alignText === 0){
            alignment = "left"
        } else if(this.state.alignText === 1){
            alignment = "center"
        } else if(this.state.alignText === 2){
            alignment = "right"
        } else {
            alignment = "justify"
        }


        //Bibliothèque de components
        var textArea = <div>
            <p style={sections}><strong className="myStrong">Button Value</strong></p>      

            <textarea
            onChange={this.handleChange}
            placeholder='Put some text here'
            defaultValue={this.state.myButtonText}
            style={{ width:"90%", height: 35, fontSize: 22, textAlign:"left", fontFamily:'arial', marginTop:10, borderRadius:10, paddingTop:15, paddingLeft:20 }}
            />
        </div>;

        var myAlignText = <div>
            <p style={sections}><strong className="myStrong">Text Align</strong></p>      
            <InputRange
            maxValue={3}
            minValue={0}
            value={this.state.alignText}
            onChange={alignText => this.setState({ alignText })} /> 
            <br />
            <br />                
            <p style={labels}>Text align - <strong className="myStrong">{alignment}</strong></p>
        </div>


        // BOUTON //
        var widthCursor = <div>  
        <p style={sections}><strong className="myStrong">{this.state.myComponent.toUpperCase()} Size</strong></p>      
        <InputRange
        maxValue={1000}
        minValue={100}
        value={this.state.value}
        onChange={value => this.setState({ value })} /> 
        <br />                
        <p style={labels}>Width - <strong className="myStrong">{this.state.value}px</strong></p>
        </div>;

        var heightCursor = <div>    
        <InputRange
        maxValue={1000}
        minValue={40}
        value={this.state.value2}
        onChange={value2 => this.setState({ value2 })} />
        <br />
        <p style={labels}>Height - <strong className="myStrong">{this.state.value2}px</strong></p>
        </div>;

        var buttonBackColor = <div>
        <p style={sections}><strong className="myStrong">{this.state.myComponent.toUpperCase()} Color</strong></p>    
        <div style={{ display:"flex", flexDirection:'row' }}>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.red}
        onChange={red => this.setState({ red })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.green}
        onChange={green => this.setState({ green })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%" }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.blue}
        onChange={blue => this.setState({ blue })} />
        </span>
        </div>

        <br />
        <p style={labels}>Background Color rgb(<strong className="myStrong">{this.state.red}</strong> / <strong className="myStrong">{this.state.green}</strong> / <strong className="myStrong">{this.state.blue}</strong>)</p>
        
        </div>;


var textShadowColor = <div>
<p style={sections}><strong className="myStrong">Text Shadow Color</strong></p>    
<div style={{ display:"flex", flexDirection:'row' }}>

<span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
<InputRange
maxValue={255}
minValue={0}
value={this.state.red}
onChange={red => this.setState({ red })} />
</span>

<span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
<InputRange
maxValue={255}
minValue={0}
value={this.state.green}
onChange={green => this.setState({ green })} />
</span>

<span style={{ display:"flex", flexDirection:"row", width: "31%" }}>
<InputRange
maxValue={255}
minValue={0}
value={this.state.blue}
onChange={blue => this.setState({ blue })} />
</span>
</div>

<br />
<p style={labels}>Text Shadow Color rgb(<strong className="myStrong">{this.state.red}</strong> / <strong className="myStrong">{this.state.green}</strong> / <strong className="myStrong">{this.state.blue}</strong>)</p>

</div>;




        var textSettings = <div>
        <br />
        <br />
        <p style={sections}><strong className="myStrong">Text size & Color</strong></p>

        <div>    
        <InputRange
        maxValue={80}
        minValue={10}
        value={this.state.textSize}
        onChange={textSize => this.setState({ textSize })} />
        <br />             
        <p style={labels}>Text Size - <strong className="myStrong">{this.state.textSize}px</strong></p>
        </div>

        <div style={{ display:"flex", flexDirection:'row'}}>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
                <InputRange
                maxValue={255}
                minValue={0}
                value={this.state.textRed}
                onChange={textRed => this.setState({ textRed })}/>
                </span>

                <span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
                <InputRange
                maxValue={255}
                minValue={0}
                value={this.state.textGreen}
                onChange={textGreen => this.setState({ textGreen })} />
                </span>

                <span style={{ display:"flex", flexDirection:"row", width: "31%"}}>
                <InputRange
                maxValue={255}
                minValue={0}
                value={this.state.textBlue}
                onChange={textBlue => this.setState({ textBlue })} />
                </span>
            </div>
            <br />
            <p style={labels}>Text Color rgb(<strong className="myStrong">{this.state.textRed}</strong> / <strong className="myStrong">{this.state.textGreen}</strong> / <strong className="myStrong">{this.state.textBlue}</strong>)</p>
        </div>;





        var widthCursorImage = <div>
        <p style={sections}><strong className="myStrong">{this.state.myComponent.toLocaleUpperCase()} Size</strong></p>
        <InputRange
        maxValue={1000}
        minValue={100}
        value={this.state.sizeWidthImage}
        onChange={sizeWidthImage => this.setState({ sizeWidthImage })} /> 
        <br />
        <p style={labels}>Width - <strong className="myStrong">{this.state.sizeWidthImage}px</strong></p>
        </div>;

        var heightCursorImage = <div>    
        <InputRange
        maxValue={1000}
        minValue={40}
        value={this.state.sizeHeightImage}
        onChange={sizeHeightImage => this.setState({ sizeHeightImage })} />
        <br />
        <p style={labels}>Height - <strong className="myStrong">{this.state.sizeHeightImage}px</strong></p>
        </div>;



var sliderWidth = <div>
<p style={sections}><strong className="myStrong">{this.state.myComponent.toLocaleUpperCase()} Size</strong></p>
<InputRange
maxValue={1000}
minValue={100}
value={this.state.sliderWidth}
onChange={sliderWidth => this.setState({ sliderWidth })} /> 
<br />
<p style={labels}>Width - <strong className="myStrong">{this.state.sliderWidth}px</strong></p>
</div>;

var sliderHeight = <div>    
<InputRange
maxValue={20}
minValue={1}
value={this.state.sliderHeight}
onChange={sliderHeight => this.setState({ sliderHeight })} />
<br />
<p style={labels}>Height - <strong className="myStrong">{this.state.sliderHeight}px</strong></p>
</div>;



        var widthCursorVideo = <div>
        <p style={sections}><strong className="myStrong">{this.state.myComponent.toLocaleUpperCase()} Size</strong></p>
        <InputRange
        maxValue={1000}
        minValue={100}
        value={this.state.sizeWidthVideo}
        onChange={sizeWidthVideo => this.setState({ sizeWidthVideo })} /> 
        <br />
        <p style={labels}>Width - <strong className="myStrong">{this.state.sizeWidthVideo}px</strong></p>
        </div>;

        var heightCursorVideo = <div>    
        <InputRange
        maxValue={1000}
        minValue={40}
        value={this.state.sizeHeightVideo}
        onChange={sizeHeightVideo => this.setState({ sizeHeightVideo })} />
        <br />
        <p style={labels}>Height - <strong className="myStrong">{this.state.sizeHeightVideo}px</strong></p>
        </div>;

        

    var transformSettings = <div>
        <br />           
        <br />           
        <br />           
        <p style={sections}><strong className="myStrong">Transformations</strong></p>
        
        <InputRange
        maxValue={180}
        minValue={0}
        value={this.state.imgRotate}
        onChange={imgRotate => this.setState({ imgRotate })} />
        <br />           
        <p style={labels}>Rotate - <strong className="myStrong">{this.state.imgRotate}px</strong></p>

        <InputRange
        maxValue={180}
        minValue={0}
        value={this.state.imgRotateX}
        onChange={imgRotateX => this.setState({ imgRotateX })} />
        <br />                         
        <p style={labels}>Rotate X - <strong className="myStrong">{this.state.imgRotateX}px</strong></p>
        
        <InputRange
        maxValue={180}
        minValue={0}
        value={this.state.imgRotateY}
        onChange={imgRotateY => this.setState({ imgRotateY })} />
        <br />          
        <p style={labels}>Rotate Y - <strong className="myStrong">{this.state.imgRotateY}px</strong></p>


        <InputRange
        maxValue={180}
        minValue={0}
        value={this.state.skewX}
        onChange={skewX => this.setState({ skewX })} />
        <br />            
        <p style={labels}>skewX - <strong className="myStrong">{this.state.skewX}deg</strong></p>

        <InputRange
        maxValue={180}
        minValue={0}
        value={this.state.skewY}
        onChange={skewY => this.setState({ skewY })} />
        <br />             
        <p style={labels}>skewY - <strong className="myStrong">{this.state.skewY}deg</strong></p>

        <InputRange
        maxValue={2}
        minValue={1}
        value={this.state.imgsScale}
        onChange={imgsScale => this.setState({ imgsScale })} />
        <br />             
        <p style={labels}>Scale - <strong className="myStrong">{this.state.imgsScale}px</strong></p>
    </div>


    var borderSettings = <div>
    <p style={sections}><strong className="myStrong">Border & Shape</strong></p>

    <div>   
        <InputRange
        maxValue={1000}
        minValue={0}
        value={this.state.value3}
        onChange={value3 => this.setState({ value3 })} />
        <br />                 
        <p style={labels}>Radius - <strong className="myStrong">{this.state.value3}px</strong></p>
    </div>

    <div>    
        <InputRange
        maxValue={30}
        minValue={0}
        value={this.state.borderW}
        onChange={borderW => this.setState({ borderW })} />
        <br />
        <p style={labels}>Border Width - <strong className="myStrong">{this.state.borderW}px</strong></p>
    </div>

    <div style={{ display:"flex", flexDirection:'row' }}>

    <span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
                <InputRange
                maxValue={255}
                minValue={0}
                value={this.state.borderRed}
                onChange={borderRed => this.setState({ borderRed })} />
                </span>

                <span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
                <InputRange
                maxValue={255}
                minValue={0}
                value={this.state.borderGreen}
                onChange={borderGreen => this.setState({ borderGreen })} />
                </span>

                <span style={{ display:"flex", flexDirection:"row", width: "31%", marginRight:15 }}>
                <InputRange
                maxValue={255}
                minValue={0}
                value={this.state.borderBlue}
                onChange={borderBlue => this.setState({ borderBlue })} />
                </span>
            </div>
            <br />
            <p style={labels}>Border Color rgb(<strong className="myStrong">{this.state.borderRed}</strong> / <strong className="myStrong">{this.state.borderGreen}</strong> / <strong className="myStrong">{this.state.borderBlue}</strong>)</p>

    </div>;

    var shadowSettings = <div>        
        <br /> 
        <br />  
        <p style={sections}><strong className="myStrong">Shadow color and shape</strong></p>

        <div style={{ display:"flex", flexDirection:'row' }}>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 15 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.shadowRed}
        onChange={shadowRed => this.setState({ shadowRed })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 15 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.shadowGreen}
        onChange={shadowGreen => this.setState({ shadowGreen })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 15 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.shadowBlue}
        onChange={shadowBlue => this.setState({ shadowBlue })} />
        </span>
    </div>
    <br />
    <p style={labels}>Shadow Color rgb(<strong className="myStrong">{this.state.shadowRed}</strong> / <strong className="myStrong">{this.state.shadowGreen}</strong> / <strong className="myStrong">{this.state.shadowBlue}</strong>)</p>

        <div style={{ display:"flex", flexDirection:'row' }}>
        <span style={{ display:"flex", flexDirection:"row", width: "23%", margin: 10 }}>
                <InputRange
                maxValue={30}
                minValue={-30}
                value={this.state.shadowTop}
                onChange={shadowTop => this.setState({ shadowTop })} />
            </span>

            <span style={{ display:"flex", flexDirection:"row", width: "23%", margin: 10 }}>
                <InputRange
                maxValue={30}
                minValue={-30}
                value={this.state.shadowRight}
                onChange={shadowRight => this.setState({ shadowRight })} />
            </span>

            <span style={{ display:"flex", flexDirection:"row", width: "23%", margin: 10 }}>
                <InputRange
                maxValue={350}
                minValue={-350}
                value={this.state.shadowBottom}
                onChange={shadowBottom => this.setState({ shadowBottom })} />
            </span>


            <span style={{ display:"flex", flexDirection:"row", width: "23%", margin: 10 }}>
                <InputRange
                maxValue={50}
                minValue={-50}
                value={this.state.shadowLeft}
                onChange={shadowLeft => this.setState({ shadowLeft })} />
            </span>
        </div>

        <br />
        <p style={labels}>BoxShadow (<strong className="myStrong">{this.state.shadowTop}px</strong> / <strong className="myStrong">{this.state.shadowRight}px</strong> / <strong className="myStrong">{this.state.shadowBottom}px</strong> / <strong className="myStrong">{this.state.shadowLeft}px</strong>)</p>
    </div>

    var widthGraph = <span style={{ display:"flex", flexDirection:"row", margin: 20 }}>
    <InputRange
    maxValue={100}
    minValue={0}
    value={this.state.data1}
    onChange={data1 => this.setState({ data1 })} />
    </span>


    var heightGraph = <span style={{ display:"flex", flexDirection:"row", margin: 20 }}>
    <InputRange
    maxValue={300}
    minValue={150}
    value={this.state.shadowLeft}
    onChange={shadowLeft => this.setState({ shadowLeft })} />
    </span>

        var data1 = <span style={{ display:"flex", flexDirection:"column" }}>
        <br />
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.data1}
        onChange={data1 => this.setState({ data1 })} />
        <br />
        <p style={labels}>Data 1 (<strong className="myStrong">{this.state.data1}%</strong>)</p>
        </span>
        
        var data2 = <span style={{ display:"flex", flexDirection:"column" }}>
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.data2}
        onChange={data2 => this.setState({ data2 })} />
        <br />
        <p style={labels}>Data 1 (<strong className="myStrong">{this.state.data2}%</strong>)</p>
        </span>

        var data3 = <span style={{ display:"flex", flexDirection:"column" }}>
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.data3}
        onChange={data3 => this.setState({ data3 })} />
        <br />
        <p style={labels}>Data 1 (<strong className="myStrong">{this.state.data3}%</strong>)</p>
        </span>

        var data4 = <span style={{ display:"flex", flexDirection:"column" }}>
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.data4}
        onChange={data4 => this.setState({ data4 })} />
        <br />
        <p style={labels}>Data 1 (<strong className="myStrong">{this.state.data4}%</strong>)</p>
        </span>

        var data5 = <span style={{ display:"flex", flexDirection:"column" }}>
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.data5}
        onChange={data5 => this.setState({ data5 })} />
        <br />
        <p style={labels}>Data 1 (<strong className="myStrong">{this.state.data4}%</strong>)</p>
        </span>


var cursorGradientsFrom = <div>
<div style={{ display:"flex", flexDirection:'row'}}>
    <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
    <InputRange
    maxValue={255}
    minValue={0}
    value={this.state.fromGradRed}
    onChange={fromGradRed => this.setState({ fromGradRed })} />
    </span>

    <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
    <InputRange
    maxValue={255}
    minValue={0}
    value={this.state.fromGradGreen}
    onChange={fromGradGreen => this.setState({ fromGradGreen })} />
    </span>

    <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
    <InputRange
    maxValue={255}
    minValue={0}
    value={this.state.fromGradBlue}
    onChange={fromGradBlue => this.setState({ fromGradBlue })} />
    </span>
    <br />
    </div>
    <p style={labels}>Gradient From Color rgb(<strong className="myStrong">{this.state.fromGradRed}</strong> / <strong className="myStrong">{this.state.fromGradGreen}</strong> / <strong className="myStrong">{this.state.fromGradBlue}</strong>)</p>
    </div>

var cursorGradientsTo = <div>

        <div style={{ display:"flex", flexDirection:'row' }}>
        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.toGradRed}
        onChange={toGradRed => this.setState({ toGradRed })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.toGradGreen}
        onChange={toGradGreen => this.setState({ toGradGreen })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.toGradBlue}
        onChange={toGradBlue => this.setState({ toGradBlue })} />
        </span>
</div>
    <p style={labels}>Gradient From Color rgb(<strong className="myStrong">{this.state.toGradRed}</strong> / <strong className="myStrong">{this.state.toGradGreen}</strong> / <strong className="myStrong">{this.state.toGradBlue}</strong>)</p>

<br></br>
        <br></br>
        <br></br>

                <select name="pets" id="pet-select" className="selectorValue" style={{ width: "100%" }} value={this.state.myGradientType} onChange={this.handleGradientType} >
                    <option value="linear">Linear gradient</option>
                    <option value="radial">Radial gradient</option>
                </select>

        <br></br>
        <br></br>
        <br></br>

</div>



var cursorsBorderCard = <div>
        <div style={{ display:"flex", flexDirection:'row' }}>
        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.borderTopLeftRad}
        onChange={borderTopLeftRad => this.setState({ borderTopLeftRad })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.borderTopRightRad}
        onChange={borderTopRightRad => this.setState({ borderTopRightRad })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.borderBottomLeftRad}
        onChange={borderBottomLeftRad => this.setState({ borderBottomLeftRad })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={100}
        minValue={0}
        value={this.state.borderBottomRightRad}
        onChange={borderBottomRightRad => this.setState({ borderBottomRightRad })} />
        </span>
        </div>
        <br />
        <p style={labels}>Border Radius Top Left: <strong className="myStrong">{this.state.borderTopLeftRad}</strong> / Top Right: <strong className="myStrong">{this.state.borderTopRightRad}</strong> / Bottom Left: <strong className="myStrong">{this.state.borderBottomLeftRad}</strong> / Bottom Right: <strong className="myStrong">{this.state.borderBottomRightRad}</strong></p>
</div>


    var cursorSizeCard = <div>  
    <p style={sections}><strong className="myStrong">{this.state.myComponent.toUpperCase()} Size</strong></p>      
    <InputRange
    maxValue={600}
    minValue={200}
    value={this.state.widthCard}
    onChange={widthCard => this.setState({ widthCard })} /> 
    <br />                
    <p style={labels}>Width - <strong className="myStrong">{this.state.widthCard}px</strong></p>

    <InputRange
    maxValue={550}
    minValue={200}
    value={this.state.heightCard}
    onChange={heightCard => this.setState({ heightCard })} />
    <br />
    <p style={labels}>Height - <strong className="myStrong">{this.state.heightCard}px</strong></p>
    </div>

var cursorSizeImgCard = <div>  
<p style={sections}><strong className="myStrong">Image Size</strong></p>      
<InputRange
maxValue={600}
minValue={200}
value={this.state.widthImageCard}
onChange={widthImageCard => this.setState({ widthImageCard })} /> 
<br />                
<p style={labels}>Width - <strong className="myStrong">{this.state.widthImageCard}px</strong></p>

<InputRange
maxValue={550}
minValue={100}
value={this.state.heightImageCard}
onChange={heightImageCard => this.setState({ heightImageCard })} />
<br />
<p style={labels}>Height - <strong className="myStrong">{this.state.heightImageCard}px</strong></p>
</div>

var cursorSizeButtonCard = <div>  
<p style={sections}><strong className="myStrong">Button Size</strong></p>      
<InputRange
maxValue={600}
minValue={200}
value={this.state.widthButtonCard}
onChange={widthButtonCard => this.setState({ widthButtonCard })} /> 
<br />                
<p style={labels}>Width - <strong className="myStrong">{this.state.widthButtonCard}px</strong></p>

<InputRange
maxValue={550}
minValue={20}
value={this.state.heightButtonCard}
onChange={heightButtonCard => this.setState({ heightButtonCard })} />
<br />
<p style={labels}>Height - <strong className="myStrong">{this.state.heightButtonCard}px</strong></p>
</div>


    var cursorTextCard = <div>

        <InputRange
        maxValue={40}
        minValue={10}
        value={this.state.textSizeCard}
        onChange={textSizeCard => this.setState({ textSizeCard })} />
        <br />
        <p style={labels}>Text Size Card - <strong className="myStrong">{this.state.heightButtonCard}px</strong></p>  
      
    <p style={sections}><strong className="myStrong">Card Text Color</strong></p>      
      <div style={{ display:"flex", flexDirection:'row' }}>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.colorTextCardRed}
        onChange={colorTextCardRed => this.setState({ colorTextCardRed })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.colorTextCardGreen}
        onChange={colorTextCardGreen => this.setState({ colorTextCardGreen })} />
        </span>

        <span style={{ display:"flex", flexDirection:"row", width: "31%", margin: 20 }}>
        <InputRange
        maxValue={255}
        minValue={0}
        value={this.state.colorTextCardBlue}
        onChange={colorTextCardBlue => this.setState({ colorTextCardBlue })} />
        </span>

        </div>
        <br />
        <p style={labels}>Color Text rgb(<strong className="myStrong">{this.state.colorTextCardRed}</strong>, <strong className="myStrong">{this.state.colorTextCardGreen}</strong>, <strong className="myStrong">{this.state.colorTextCardBlue}</strong>)</p>
</div>



    var clearButton = <div>
    <input 
    onClick={  
        () => this.setState({ 
            myComponentSelected: '',
            actionText:"",

            myComponent:"",

            showcaseRed:255,
            showcaseGreen:255,
            showcaseBlue:255,

            //size button
            value: 250,
            value2: 90,

            sizeWidthVideo:640,
            sizeHeightVideo: 358,

            sizeWidthImage: 400,
            sizeHeightImage: 200,

            //radius bouton
            value3:0,

            //text
            valueButtonText:"My button !",
            textRed:255,
            textGreen:255,
            textBlue:255,
            textSize: 18,

            //button color
            red:50,
            green:50,
            blue:50,

            //border
            borderW:0,
            borderRed:90,
            borderGreen:90,
            borderBlue:90,

            //box shadow
            shadowRed:0,
            shadowGreen:0,
            shadowBlue:0,
            shadowTop:10,
            shadowRight:20,
            shadowBottom:30,
            shadowLeft:0,


            //image 3D
            imgRotate:0,
            imgRotateX:0,
            imgRotateY:0,
            imgRotateZ:0,
            imgsScale: 1,
            skewX:0,
            skewY:0,

            alignText: 1,
            alignment: 'center',

            data1: 30,
            data2: 20,
            data3: 45,
            data4: 80,
            data5: 13,

            fromGradRed:0,
            fromGradGreen:0,
            fromGradBlue: 0,
            toGradRed: 0,
            toGradGreen: 0,
            toGradBlue: 0,

            myGradientType: 'linear',

            sliderWidth: 200,
            sliderHeight: 5,

            borderTopLeftRad:0,
            borderTopRightRad:0,
            borderBottomLeftRad:0,
            borderBottomRightRad:0,
            widthCard: 350,
            heightCard: 465,
            widthImageCard: 350,
            heightImageCard: 150,
            widthButtonCard: 150,
            heightButtonCard: 65,
            colorTextCardRed: 255,
            colorTextCardGreen: 255,
            colorTextCardBlue: 255,
            textSizeCard: 20,

            })
            } 
            type="button" value="Clear all" style={{ width: "94%", height: 60, borderRadius: 10, backgroundColor: "rgb(255, 63, 52)", margin: 10, color:"white", fontSize:28 }} />
        </div>;


    if(this.state.myComponentSelected === ""){
        textArea = null; widthCursor = null; buttonBackColor = null; heightCursor = null; textSettings = null; borderSettings = null; shadowSettings = null; clearButton = null; transformSettings = null;         
        widthCursorImage = null; heightCursorImage=null; widthCursorVideo=null; heightCursorVideo=null; myAlignText=null;
        transformSettings=null;shadowSettings=null; data1=null; data2=null;data3=null;data4=null;data5=null; cursorGradientsFrom=null;
        cursorGradientsTo=null; sliderHeight=null; sliderWidth=null;
        cursorsBorderCard = null
        cursorSizeCard =null
        cursorSizeImgCard = null
        cursorSizeButtonCard = null
        cursorTextCard = null
        textShadowColor = null
        widthGraph = null
        heightGraph = null
        process = process
    }

    if(this.state.myComponentSelected === "choose"){
        textArea = null; widthCursor = null; buttonBackColor = null; heightCursor = null; textSettings = null; borderSettings = null; shadowSettings = null; clearButton = null; transformSettings = null;         
        widthCursorImage = null; heightCursorImage=null; widthCursorVideo=null; heightCursorVideo=null; myAlignText=null;
        transformSettings=null;shadowSettings=null; data1=null; data2=null;data3=null;data4=null;data5=null; cursorGradientsFrom=null;
        cursorGradientsTo=null; sliderHeight=null; sliderWidth=null;
        cursorsBorderCard = null
        cursorSizeCard =null
        cursorSizeImgCard = null
        cursorSizeButtonCard = null
        cursorTextCard = null
        textShadowColor = null
        widthGraph = null
        heightGraph = null
        process = process
    }

    if(this.state.myComponentSelected === "button"){
        process = null
        widthCursorImage = null
        heightCursorImage=null
        widthCursorVideo = null
        heightCursorVideo =null
        myAlignText = null;
        transformSettings = null
        cursorGradientsFrom = null
        cursorGradientsTo = null
        data1 = null 
        data2 = null
        data3 = null
        data4 = null
        data5 = null
        widthCursor = widthCursor 
        heightCursor = heightCursor
        buttonBackColor = buttonBackColor
        textArea = textArea
        textSettings = textSettings
        borderSettings = borderSettings
        shadowSettings = shadowSettings
        sliderHeight = null
        sliderWidth = null
        cursorsBorderCard = null
        cursorSizeCard =null
        cursorSizeImgCard = null
        cursorSizeButtonCard = null
        cursorTextCard = null
        textShadowColor = null

        widthGraph = null
        heightGraph = null
        clearButton = clearButton
    }


    if(this.state.myComponentSelected === "image"){
        process = null
        widthCursor = null
        heightCursor = null
        textArea = null
        widthCursorVideo = null
        heightCursorVideo =null
        cursorGradientsFrom = null
        cursorGradientsTo = null
        data1 = null 
        data2 = null
        data3 = null
        data4 = null
        data5 = null
        buttonBackColor = null;
        textSettings = null
        myAlignText=null
        widthCursorImage = widthCursorImage; 
        heightCursorImage = heightCursorImage;
        transformSettings = transformSettings
        borderSettings = borderSettings;
        shadowSettings = shadowSettings;
        sliderHeight = null
        sliderWidth = null
        cursorsBorderCard = null
        cursorSizeCard =null
        cursorSizeImgCard = null
        cursorSizeButtonCard = null
        cursorTextCard = null
        textShadowColor = null

        widthGraph = null
        heightGraph = null

        clearButton = clearButton;
    }

    if(this.state.myComponentSelected === "video"){
        process = null
        textArea = null
        textSettings = null
        myAlignText=null
        borderSettings = borderSettings;
        widthCursor = null
        heightCursor = null
        widthCursorImage = null
        heightCursorImage=null
        cursorGradientsFrom = null
        cursorGradientsTo = null
        data1 = null 
        data2 = null
        data3 = null
        data4 = null
        data5 = null
        transformSettings = transformSettings
        widthCursorVideo = widthCursorVideo; 
        heightCursorVideo = heightCursorVideo;
        buttonBackColor = null;
        shadowSettings = shadowSettings; 
        sliderHeight = null
        sliderWidth = null
        clearButton = clearButton
        cursorGradientsTo=null; sliderHeight=null; sliderWidth=null;
        cursorsBorderCard = null
        cursorSizeCard =null
        cursorSizeImgCard = null
        cursorSizeButtonCard = null
        cursorTextCard = null
        widthGraph = null
        heightGraph = null
        textShadowColor = null

    }

        if(this.state.myComponentSelected === "text"){
            process = null
            widthCursorImage = null
            heightCursorImage=null
            widthCursorVideo = null
            heightCursorVideo =null
            textArea = null
            widthCursor = null 
            heightCursor = null
            myAlignText = myAlignText
            buttonBackColor = null
            textShadowColor = textShadowColor
            textSettings = textSettings
            borderSettings = null
            shadowSettings = null
            clearButton = clearButton
            cursorGradientsFrom = null
            cursorGradientsTo = null
            data1 = null 
            data2 = null
            data3 = null
            data4 = null
            data5 = null
            transformSettings = null
            sliderHeight = null
            sliderWidth = null
            cursorsBorderCard = null
            cursorSizeCard =null
            cursorSizeImgCard = null
            cursorSizeButtonCard = null
            cursorTextCard = null
    
            widthGraph = null
            heightGraph = null
        }

        if(this.state.myComponentSelected === "input"){
            process = null
            widthCursorImage = null
            heightCursorImage=null
            widthCursorVideo = null
            heightCursorVideo =null
            textArea = null
            widthCursor = widthCursor 
            heightCursor = heightCursor
            widthGraph = null
            heightGraph = null
            transformSettings=null
            cursorGradientsFrom = null
            cursorGradientsTo = null
            data1 = null 
            data2 = null
            data3 = null
            data4 = null
            data5 = null
            buttonBackColor = buttonBackColor
            textSettings = textSettings
            borderSettings = borderSettings
            shadowSettings = shadowSettings
            sliderHeight = null
            sliderWidth = null
            cursorsBorderCard = null
            cursorSizeCard =null
            cursorSizeImgCard = null
            cursorSizeButtonCard = null
            cursorTextCard = null
            textShadowColor = null

            clearButton = clearButton
        }

        if(this.state.myComponentSelected === "slider"){
            process = null
            sliderWidth = sliderWidth
            sliderHeight = sliderHeight
            widthCursorImage = null
            heightCursorImage=null
            widthCursorVideo = null
            heightCursorVideo =null
            textArea = null
            widthCursor = null 
            heightCursor = null
            widthGraph = null
            heightGraph = null
            transformSettings=null
            cursorGradientsFrom = null
            cursorGradientsTo = null
            data1 = null 
            data2 = null
            data3 = null
            data4 = null
            data5 = null
            buttonBackColor = buttonBackColor
            myAlignText = null
            textSettings = null
            borderSettings = null
            shadowSettings = shadowSettings
            textShadowColor = null

            cursorsBorderCard = null
            cursorSizeCard =null
            cursorSizeImgCard = null
            cursorSizeButtonCard = null
            cursorTextCard = null
            clearButton = clearButton
        }



    if(this.state.myComponentSelected === "graph"){
        process = null
        widthCursor = null
        heightCursor = null
        textArea = null
        sliderWidth = null
        sliderHeight = null
        myAlignText = null
        widthCursorVideo = null
        heightCursorVideo =null
        widthCursorImage = null; 
        heightCursorImage = null;
        transformSettings = null
        buttonBackColor = buttonBackColor;
        textSettings = null
        borderSettings = borderSettings;
        shadowSettings = shadowSettings;
        transformSettings=null
        cursorGradientsFrom = null
        cursorGradientsTo = null
        data1 = data1 
        data2 = data2
        data3 = data3
        data4 = data4
        data5 = data5
        widthGraph = widthGraph
        heightGraph = heightGraph
        textShadowColor = null

        cursorsBorderCard = null
        cursorSizeCard =null
        cursorSizeImgCard = null
        cursorSizeButtonCard = null
        cursorTextCard = null

        clearButton = clearButton

    }

    if(this.state.myComponentSelected === "gradient"){
        process = null
        widthCursor = null
        heightCursor = null
        textArea = null
        widthCursorVideo = null
        heightCursorVideo =null
        widthCursorImage = null; 
        heightCursorImage = null;
        transformSettings = null
        buttonBackColor = null;
        textSettings = null
        borderSettings = null;
        shadowSettings = null;
        widthGraph = null
        heightGraph = null
        myAlignText = null
        sliderHeight = null
        sliderWidth = null
        data1 = null 
        data2 = null
        data3 = null
        data4 = null
        data5 = null
        cursorGradientsFrom = cursorGradientsFrom;
        cursorGradientsTo = cursorGradientsTo;
        clearButton = clearButton
        cursorsBorderCard = null
        cursorSizeCard =null
        cursorSizeImgCard = null
        cursorSizeButtonCard = null
        cursorTextCard = null
        textShadowColor = null

    }

    if(this.state.myComponentSelected === "card"){

        cursorsBorderCard = cursorsBorderCard
        process = null
        cursorSizeCard =cursorSizeCard
        cursorSizeImgCard = cursorSizeImgCard
        cursorSizeButtonCard = cursorSizeButtonCard
        cursorTextCard = cursorTextCard
        widthCursor = null
        heightCursor = null
        textArea = null
        widthCursorVideo = null
        heightCursorVideo =null
        widthCursorImage = null; 
        heightCursorImage = null;
        transformSettings = null
        buttonBackColor = buttonBackColor;
        textSettings = null
        borderSettings =  null;
        shadowSettings = shadowSettings;
        widthGraph = null
        heightGraph = null
        myAlignText = null
        sliderHeight = null
        sliderWidth = null
        data1 = null 
        data2 = null
        data3 = null
        data4 = null
        data5 = null
        cursorGradientsFrom = cursorGradientsFrom;
        cursorGradientsTo = null;
        textShadowColor = null

        clearButton = clearButton
    }


    var myGraph = <div style={{ display:"flex", flexDirection: "row", padding:10, paddingLeft:30,paddingRight:30 ,height: 400, width: 900, alignItems:"flex-end", justifyContent:'center',
        backgroundColor: `rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})`,
    }}>

        <div style={{ backgroundColor: "red", borderRadius: this.state.value3,    
        width: "15%", height: this.state.data1*3, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
        border: `${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
        boxShadow: ""+this.state.shadowTop+"px "+ this.state.shadowRight+"px "+this.state.shadowBottom+"px "+ this.state.shadowLeft+"px rgb("+this.state.shadowRed+","+ this.state.shadowGreen+","+ this.state.shadowBlue+")",
        }}>
        <p style={labels}><strong>{this.state.data1}</strong></p>
        </div>

        <div style={{ backgroundColor: "blue", borderRadius: this.state.value3,    
        width: "15%", height: this.state.data2*3, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
        border: `${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
        boxShadow: ""+this.state.shadowTop+"px "+ this.state.shadowRight+"px "+this.state.shadowBottom+"px "+ this.state.shadowLeft+"px rgb("+this.state.shadowRed+","+ this.state.shadowGreen+","+ this.state.shadowBlue+")",
        }}>
        <p style={labels}><strong>{this.state.data2}</strong></p>
        </div>
        <div style={{ backgroundColor: "purple", borderRadius: this.state.value3,    
        width: "15%", height: this.state.data3*3, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
        border: `${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
        boxShadow: ""+this.state.shadowTop+"px "+ this.state.shadowRight+"px "+this.state.shadowBottom+"px "+ this.state.shadowLeft+"px rgb("+this.state.shadowRed+","+ this.state.shadowGreen+","+ this.state.shadowBlue+")",
        }}>
        <p style={labels}><strong>{this.state.data3}</strong></p>
        </div>
        <div style={{ backgroundColor: "rgba(255, 99, 72,1.0)", borderRadius: this.state.value3,    
        width: "15%", height: this.state.data4*3, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
        border: `${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
        boxShadow: ""+this.state.shadowTop+"px "+ this.state.shadowRight+"px "+this.state.shadowBottom+"px "+ this.state.shadowLeft+"px rgb("+this.state.shadowRed+","+ this.state.shadowGreen+","+ this.state.shadowBlue+")",
       }}>
        <p style={labels}><strong>{this.state.data4}</strong></p>
        </div>
        <div style={{ backgroundColor: "green", borderRadius: this.state.value3,    
        width: "15%", height: this.state.data5*3, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
        border: `${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
        boxShadow: ""+this.state.shadowTop+"px "+ this.state.shadowRight+"px "+this.state.shadowBottom+"px "+ this.state.shadowLeft+"px rgb("+this.state.shadowRed+","+ this.state.shadowGreen+","+ this.state.shadowBlue+")",
        }}>            
        <p style={labels}><strong>{this.state.data5}</strong></p>
        </div>
    </div>


var myGraphCode = `<div style={{ display:"flex", flexDirection: "row", padding:10, paddingLeft:30,paddingRight:30 ,height: 400, width: "60%", alignItems:"flex-end", justifyContent:'center',
    backgroundColor: "rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})",
    }}>

    <div style={{ backgroundColor: "red", borderRadius: ${this.state.value3},    
    width: "15%", height: ${this.state.data1*3}, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
    border: "${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })",
    boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})"    
    }}>
    <p style={labels}><strong>${this.state.data1}</strong></p>
    </div>

    <div style={{ backgroundColor: "blue", borderRadius: ${this.state.value3},    
    width: "15%", height: ${this.state.data2*3}, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
    border: "${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })",
    boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})"
    }}>
    <p style={labels}><strong>${this.state.data2}</strong></p>
    </div>
    <div style={{ backgroundColor: "purple", borderRadius: ${this.state.value3},    
    width: "15%", height: ${this.state.data3*3}, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
    border: "${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })",
    boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})"
    }}>
    <p style={labels}><strong>${this.state.data3}</strong></p>
    </div>
    <div style={{ backgroundColor: "rgba(255, 99, 72,1.0)", borderRadius: ${this.state.value3},    
    width: "15%", height: ${this.state.data4*3}, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
    border: "${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })",
    boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})"
    }}>
    <p style={labels}><strong>${this.state.data4}</strong></p>
    </div>
    <div style={{ backgroundColor: "green", borderRadius: ${this.state.value3},    
    width: "15%", height: ${this.state.data5*3}, margin: 20, display:"flex", alignItems:'center', justifyContent:'center', transition:'300ms',
    border: "${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })",
    boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})"
    }}>            
    <p style={labels}><strong>${this.state.data5}</strong></p>
    </div>
</div>`


    var myGradient = <div style={{
        width: 900, height: 400, display:'flex', justifyContent:"center", alignItems:'center',
        background: `${this.state.myGradientType}-gradient(rgb(${this.state.fromGradRed}, ${this.state.fromGradGreen}, ${this.state.fromGradBlue}), rgb(${this.state.toGradRed}, ${this.state.toGradGreen}, ${this.state.toGradBlue}) )`
    }}>
        <p style={{  fontSize: 50, color:'white'}}>Great gradient!</p>
    </div>
    

    var myGradientCode = `<div style={{
        width: "70%", height: 400, display:'flex', justifyContent:"center", alignItems:'center',
        background: "${this.state.myGradientType}-gradient(rgb(${this.state.fromGradRed}, ${this.state.fromGradGreen}, ${this.state.fromGradBlue}), rgb(${this.state.toGradRed}, ${this.state.toGradGreen}, ${this.state.toGradBlue}))"
    }}>
        <p style={{  fontSize: 50, color:'white'}}>Great gradient!</p>
    </div>`


    var myCard = <div style={{
        width: this.state.widthCard, height: this.state.heightCard, display:'flex', flexDirection:'column', 
        alignItems:'center',
        overflow:'hidden',
        backgroundColor: `rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})`, fontSize:this.state.textSize, color: `rgb(${this.state.textRed}, ${this.state.textGreen}, ${this.state.textBlue })`,
        boxShadow: ""+this.state.shadowTop+"px "+ this.state.shadowRight+"px "+this.state.shadowBottom+"px "+ this.state.shadowLeft+"px rgb("+this.state.shadowRed+","+ this.state.shadowGreen+","+ this.state.shadowBlue+")",
        borderTopLeftRadius: this.state.borderTopLeftRad, borderTopRightRadius: this.state.borderTopRightRad, borderBottomLeftRadius: this.state.borderBottomLeftRad, borderBottomRightRadius: this.state.borderBottomRightRad,
   }}>
       <img src="./plat1.jpg" alt="my illustration..."
       style={{ width: this.state.widthImageCard, height: this.state.heightImageCard,
        borderTopLeftRadius: this.state.borderTopLeftRad, borderTopRightRadius: this.state.borderTopRightRad,
        }}/>

        <p style={{  fontSize: this.state.textSizeCard, 
            color: `rgb(${this.state.colorTextCardRed}, ${this.state.colorTextCardGreen}, ${this.state.colorTextCardBlue})`,
            padding: 20, textAlign:'justify', fontWeight:'200'}}>Hello world, i'm very happy to help you to customize your React web application. This tool will help you to create an application faster and easier and will save you time</p>
       
        <input type="button" value="Discover" style={{
            width: this.state.widthButtonCard, height:this.state.heightButtonCard,
            background: `rgb(${this.state.fromGradRed}, ${this.state.fromGradGreen}, ${this.state.fromGradBlue})`,
            border:"none", color:'white', fontSize:25, textAlign:'center',
        }} />
    </div>


    var myCardCode = `<div style={{
        width: ${this.state.widthCard}, height: ${this.state.heightCard}, display:'flex', flexDirection:'column', 
        alignItems:'center',
        overflow:'hidden',
        backgroundColor: "rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})", fontSize: ${this.state.textSize}, color: "rgb(${this.state.textRed}, ${this.state.textGreen}, ${this.state.textBlue })",
        boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})",
        borderTopLeftRadius: ${this.state.borderTopLeftRad}, borderTopRightRadius: ${this.state.borderTopRightRad}, borderBottomLeftRadius: ${this.state.borderBottomLeftRad}, borderBottomRightRadius: ${this.state.borderBottomRightRad},
    }}>
    <img src="./plat1.jpg" alt="my illustration..."
    style={{ width: ${this.state.widthImageCard}, height: ${this.state.heightImageCard},
        borderTopLeftRadius: ${this.state.borderTopLeftRad}, borderTopRightRadius: ${this.state.borderTopRightRad},
        }}/>

        <p style={{  fontSize: ${this.state.textSizeCard}, 
            color: "rgb(${this.state.colorTextCardRed}, ${this.state.colorTextCardGreen}, ${this.state.colorTextCardBlue})",
            padding: 20, textAlign:'justify', fontWeight:'200'}}>Hello world, i'm very happy to help you to customize your React web application. This tool will help you to create an application faster and easier and will save you time</p>
    
        <input type="button" value="Discover" style={{
            width: ${this.state.widthButtonCard}, height: ${this.state.heightButtonCard},
            background: "rgb(${this.state.fromGradRed}, ${this.state.fromGradGreen}, ${this.state.fromGradBlue})",
            border:"none", color:'white', fontSize:25, textAlign:'center',
        }} />
    </div>`


    var myButton = <input onClick={() => this.setState({actionText: 'Bingo!'})} type="button" value={this.state.valueButtonText} 
    style={{ width: this.state.value, transition: "300ms",
        height: this.state.value2, borderRadius: this.state.value3, 
        backgroundColor: `rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})`, fontSize:this.state.textSize, color: `rgb(${this.state.textRed}, ${this.state.textGreen}, ${this.state.textBlue })`,
        borderColor: `rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
        borderWidth: this.state.borderW,
        boxShadow: ""+this.state.shadowTop+"px "+ this.state.shadowRight+"px "+this.state.shadowBottom+"px "+ this.state.shadowLeft+"px rgb("+this.state.shadowRed+","+ this.state.shadowGreen+","+ this.state.shadowBlue+")",
    }} />

    var myButtonText = 
    `<input type='button' value="${this.state.valueButtonText}" 
    style={{ width: ${this.state.value}, height: ${this.state.value2}, borderRadius: ${this.state.value3}, 
    backgroundColor: "rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})", 
    color: "rgb(${this.state.textRed}, ${this.state.textGreen}, ${this.state.textBlue})", fontSize: ${this.state.textSize},
    borderColor: "rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })",
    borderWidth: ${this.state.borderW},
    boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})"
}}/>`


    var myVideo = 
    <video width={this.state.sizeWidthVideo} height={this.state.sizeHeightVideo} controls
    style={{ 
    transform: "rotate("+this.state.imgRotate+"deg) rotateX("+this.state.imgRotateX+"deg) rotateY("+this.state.imgRotateY+"deg) rotateZ("+this.state.imgRotateZ+"deg)",
    boxShadow: ""+this.state.shadowTop+"px "+ this.state.shadowRight+"px "+this.state.shadowBottom+"px "+ this.state.shadowLeft+"px rgb("+this.state.shadowRed+","+ this.state.shadowGreen+","+ this.state.shadowBlue+")",
    transform: `rotate(${this.state.imgRotate}deg) rotateX(${this.state.imgRotateX}deg) rotateY(${this.state.imgRotateY}deg) scale(${this.state.imgsScale}) skew(${this.state.skewX}deg, ${this.state.skewY}deg)`,
    borderRadius: this.state.value3,
    border: `${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
    }}>
        <source src="../dashboard.mp4" type="video/mp4"/>
    </video>

    let myVideoText = `<video width="${this.state.sizeWidthVideo}" height="${this.state.sizeHeightVideo}" controls
    style={{
        border: "${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })",
        borderRadius: ${this.state.value3},
        boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})",
        transform: "rotate(${this.state.imgRotate}deg) rotateX(${this.state.imgRotateX}deg) rotateY(${this.state.imgRotateY}deg) scale(${this.state.imgsScale}) skew(${this.state.skewX}deg, ${this.state.skewY}deg)"
    }}>
        <source src="../dashboard.mp4" type="video/mp4"/>
    </video>`


    
    var myImage = <img src="./plat2.jpg" alt="my illustration..." 
    style={{ width: this.state.sizeWidthImage, height: this.state.sizeHeightImage, borderRadius: this.state.value3, transition: "300ms",
    border: `${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
    boxShadow: `${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})`,
    transform: `rotate(${this.state.imgRotate}deg) rotateX(${this.state.imgRotateX}deg) rotateY(${this.state.imgRotateY}deg) rotateZ(${this.state.imgRotateZ}deg) scale(${this.state.imgsScale}) skew(${this.state.skewX}deg, ${this.state.skewY}deg)`,
    }}
    />

    var myImageText = `<img src='./plat2.jpg' alt='my illustration..' style={{ width: ${this.state.sizeWidthImage}, height: ${this.state.sizeHeightImage}, borderRadius: ${this.state.value3},
    border: ("${this.state.borderW}px solid rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue}"),
    boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})",
    transform: "rotate(${this.state.imgRotate}deg) rotateX(${this.state.imgRotateX}deg) rotateY(${this.state.imgRotateY}deg) rotateZ(${this.state.imgRotateZ}deg) scale(${this.state.imgsScale}) skew(${this.state.skewX}deg, ${this.state.skewY}deg)"
    }} />`


    var mySlider = <input 
        style={{ width: this.state.sliderWidth, height: this.state.sliderHeight, marginTop: 100,
        backgroundColor: `rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})`,
        boxShadow: `${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})`,

    }} 
        type="range" min={0} max={100}
        step="1" />

        var mySliderCode = `<input 
        style={{ width: ${this.state.sliderWidth}, height: ${this.state.sliderHeight},
        backgroundColor: "rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})",
        boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})",
        }} 
        type="range" min={0} max={100}
        step="1" />`


    var myText = <p
        style={{ fontSize: this.state.textSize, color: `rgb(${this.state.textRed}, ${this.state.textGreen}, ${this.state.textBlue})`,
        textShadow: `1px 4px 2px rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})`,
        textAlign:alignment
        }}
        >Hello World let's go <br/>to personalize your text with style and simply <br/>using React Studio Code
    </p>

    var myTextCode = `<p
    style={{ 
    fontSize: ${this.state.textSize}, 
    color: "rgb(${this.state.textRed}, ${this.state.textGreen}, ${this.state.textBlue})",
    textShadow: "1px 4px 2px rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})",
    textAlign: "${alignment}"
    }}
    >Hello World let's go <br/>to personalize your text with style and simply <br/>using React Studio Code
    </p>`


    var myInputText = <textArea type="text" placeholder="Hello World" cols="60" rows="10"
    style={{ width: this.state.value, height: this.state.value2, fontSize: this.state.textSize, 
    borderRadius: this.state.value3, transition: "300ms", padding: 20, textAlign:alignment,
    backgroundColor: `rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})`, fontSize:this.state.textSize, 
    color: `rgb(${this.state.textRed}, ${this.state.textGreen}, ${this.state.textBlue })`,
    borderColor: `rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })`,
    borderWidth: this.state.borderW,
    boxShadow: `${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})`,
    }} />

    var myInputTextCode = `<textArea type="text" placeholder="Hello World" cols="60" rows="10"
    style={{ width: ${this.state.value}, height: ${this.state.value2}, fontSize: ${this.state.textSize}, 
    borderRadius: ${this.state.value3}, padding: 20, textAlign: "${alignment}",
    backgroundColor: "rgb(${this.state.red}, ${this.state.green}, ${this.state.blue})", fontSize:${this.state.textSize}, 
    color: "rgb(${this.state.textRed}, ${this.state.textGreen}, ${this.state.textBlue })",
    borderColor: "rgb(${this.state.borderRed}, ${this.state.borderGreen}, ${this.state.borderBlue })",
    borderWidth: ${this.state.borderW},
    boxShadow: "${this.state.shadowTop}px ${this.state.shadowRight}px ${this.state.shadowBottom}px ${this.state.shadowLeft}px rgb(${this.state.shadowRed}, ${this.state.shadowGreen}, ${this.state.shadowBlue})",
    }} />`
    

    return(
    <div style={{ display:"flex", flexDirection:'row' }}>
        <div style={{ display:'flex', flexDirection:"column", width:"25vw", minHeight:"100vh", paddingTop:50, backgroundColor:'black', paddingLeft:20, paddingRight:20, overflowY:'scroll' }}>
            
            <div style={{ display:"block", textAlign:'left', marginLeft:10 }}>
                <h1 style={{ color:'white', fontWeight: "200", fontSize: "2.5em", marginTop:-25 }}>STUDIO</h1>
            </div>

            <div style={{ display:"flex", flexDirection:'column', marginTop: 40, padding: 10, justifyContent:'center', marginBottom:10 }}>
                <select className="selectorValue" value={this.state.myComponentSelected} onChange={this.handleChangeComponent}>
                    <option value="choose">Choose a component</option>
                    <option value="button">Button</option>
                    <option value="image">Image</option>
                    <option value="video">Video</option>
                    <option value="input">Input</option>
                    <option value="text">Text</option>
                    <option value="slider">Slider</option>
                    <option value="graph">SmartGraph</option>
                    <option value="gradient">Gradient</option>
                    <option value="card">Card</option>
                </select>
            </div>


            {process}
            
            <div style={{ marginBottom: 20, marginTop: 20, textAlign:'left', marginLeft:10 }}>
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_donations" />
            <input type="hidden" name="business" value="9QKPMCTQD324N" />
            <input type="hidden" name="item_name" value="Pay me a coffee" />
            <input type="hidden" name="currency_code" value="EUR" />
            <input type="image" src="cupcake.png" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" width="200" />
            <img alt="" border="0" src="https://www.paypal.com/en_FR/i/scr/pixel.gif" width="1" height="1" />
            </form>
            </div>

            <br/>
            <br/>

            <p style={{ display:"flex", flexDirection:'column', bottom:0, fontWeight:"200", fontSize:'1em', color: 'white', textDecoration:'none'}}>Developed by Creazerty</p>

            {sliderWidth}
            {sliderHeight}

            {/* Video */}
            {widthCursorVideo}
            {heightCursorVideo}

            {/* button */}
            {widthCursor}
            {heightCursor}
            {buttonBackColor}


            {textShadowColor}

            {textArea}
            {textSettings}



            {/* Image */}
            {widthCursorImage}
            {heightCursorImage}


            {myAlignText}

            {cursorSizeCard}
            {cursorsBorderCard}
            {cursorSizeImgCard}
            {cursorSizeButtonCard}
            {cursorTextCard}

            {borderSettings}
            {transformSettings}
            {shadowSettings}

            {data1}
            {data2}
            {data3}
            {data4}
            {data5}

            {cursorGradientsFrom}
            {cursorGradientsTo}

            {clearButton} 


        <br /> 
        </div>

        
        <div style={{ display:'flex', flexDirection:"column",
        width:"75vw", minHeight: "70vh", backgroundColor:`rgb(${this.state.showcaseRed}, ${this.state.showcaseGreen}, ${this.state.showcaseBlue})`, padding: 50 }}>
        <h1 style={{ color:colorTitleShowcase, fontWeight: "200", fontSize: "2em", marginTop:-25, position:'absolute' }}>SHOWCASE</h1>

        {cursorsBackShowcase}


        <div style={{ display:"flex", padding:20, position:'fixed', width: '68%', height:'65vh', alignItems:'center', justifyContent:'center', marginTop:0, overflow:'hidden', transform:'scale(.65)', overflow:'visible' }}>
            <div style={{ display:"flex", marginTop: 10, justifyContent:'center', alignItems:'center', position:'fixed', width:'70%' }}>
                { this.state.myComponentSelected === 'button' ? myButton : null}
                { this.state.myComponentSelected === 'image' ? myImage : null}
                { this.state.myComponentSelected === 'video' ? myVideo : null}
                { this.state.myComponentSelected === 'slider' ? mySlider : null}
                { this.state.myComponentSelected === 'text' ? myText : null}
                { this.state.myComponentSelected === 'input' ? myInputText : null}
                { this.state.myComponentSelected === 'graph' ? myGraph : null}
                { this.state.myComponentSelected === 'gradient' ? myGradient : null}
                { this.state.myComponentSelected === 'card' ? myCard : null}
            </div>

        </div>

            {/* <p style={{ fontSize: 50, textAlign:'center', marginTop: 100 }}>{this.state.actionText}</p> */}

            <span style={{ display:"flex", flexDirection:'column', alignItems:'center'}}>
            <p 
            style={{ display:"flex", flexDirection:'column', padding:10, borderRadius:10, width:'90%',maxHeight:100, overflow:'scroll',
            backgroundColor:"#7bed9f", textAlign:'left', position:'fixed', bottom:0, border:"none", fontSize:15, transform:'scale(.7)' }}
            >
                Copy & Paste code <span>👇</span>
                <br/>
                { this.state.myComponentSelected === 'button' ? myButtonText : null}
                { this.state.myComponentSelected === 'image' ? myImageText : null}
                { this.state.myComponentSelected === 'video' ? myVideoText : null}
                { this.state.myComponentSelected === 'input' ? myInputTextCode : null}
                { this.state.myComponentSelected === 'text' ? myTextCode : null}
                { this.state.myComponentSelected === 'slider' ? mySliderCode : null}
                { this.state.myComponentSelected === 'graph' ? myGraphCode : null}
                { this.state.myComponentSelected === 'gradient' ? myGradientCode : null}
                { this.state.myComponentSelected === 'card' ? myCardCode : null}
                
            </p>

            </span>


        </div>    
    </div>
    )
    }
}

export default Studio;